import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, Download, CheckCircle, Infinity } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-2 md:py-3 px-4 overflow-hidden" data-id="element-77">
      <div className="max-w-4xl mx-auto text-center" data-id="element-78">
        <p className="text-gray-600 font-bold tracking-wider uppercase mb-0.5 text-xs md:text-sm" data-id="element-79">
          PARA DOCENTES DE PSICOLOGÍA EN SECUNDARIA
        </p>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-1" data-id="element-80">
          Resolvé todo tu año de Psicología en un solo lugar y{' '}
          <span className="bg-yellow-200 px-1" data-id="element-81">
            olvidate de planificar desde cero
          </span>{' '}
          con el KIT COMPLETO PSICOLOGÍA LISTA
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/9z2sAr3ZUzWPP5NYFVzvZY/MOCKUPS_psicologia_.png" alt="Kit Completo Psicología Lista" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-83" />
        </div>

        <h2 className="text-lg md:text-xl text-gray-700 font-medium mb-3 max-w-3xl mx-auto" data-id="element-84">
          Sistema completo de clases, secuencias, actividades y evaluaciones
          listas para usar en secundaria.{' '}
          <span className="font-bold" data-id="element-85">Todo tu año resuelto.</span>
        </h2>

        <div className="flex justify-center mb-4" data-id="element-86">
          <CTAButton onClick={scrollToPricing} className="w-full md:w-auto text-xl md:text-2xl px-8 py-5 shadow-green-500/30" data-id="element-87">
            👉 SÍ, QUIERO ACCESO INMEDIATO
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-88">
          <div className="flex items-center gap-1" data-id="element-89">
            <Shield className="w-4 h-4 text-green-600" data-id="element-90" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-91">
            <Download className="w-4 h-4 text-green-600" data-id="element-92" /> Descarga inmediata
          </div>
          <div className="flex items-center gap-1" data-id="element-93">
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-94" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1" data-id="element-95">
            <Infinity className="w-4 h-4 text-green-600" data-id="element-96" /> Acceso de por vida
          </div>
        </div>
      </div>
    </section>;
}